import styled from "styled-components";

export const ModalWrapStyled = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

export const StationModalStyled = styled.div`
  width: 348px;
  min-height: 200px;
  display: flex;
  align-items: center;
  flex-direction: column;
  background: #172a3f;
  box-shadow: 0px 8px 32px rgba(27, 27, 27, 0.08);
  border-radius: 4px;
  color: #ffffff;
  line-height: 140%;
  box-sizing: border-box;
  padding: 16px;
  z-index: 1;
  margin-top: 80px;
  position: relative;

  svg {
    position: absolute;
    top: 16px;
    right: 16px;
    cursor: pointer;
  }
`;

export const HeaderStyled = styled.div`
  width: 100%;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  font-weight: bold;
  margin-bottom: 16px;
`;

export const StationModalContentStyled = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const InputStyled = styled.input`
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1rem;
`;

export const SelectStyled = styled.select`
  padding: 0.5rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 1rem;
  background-color: white;
  cursor: pointer;

  &:disabled {
    background-color: #f5f5f5;
    cursor: not-allowed;
  }
`;

export const ActionButtonStyled = styled.button.attrs<{ disabled?: boolean }>(
  (props) => ({
    type: "button",
    disabled: props.disabled,
  })
)`
  padding: 0.75rem 1.5rem;
  background: #3f7f7d;
  color: white;
  border: 2px solid transparent;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    border: 2px solid #0f625f;
  }

  &:disabled {
    background-color: #ccc;
    cursor: not-allowed;
  }
`;

// New styled components for repeated styles
export const LabelStyled = styled.label`
  color: #b3d0e6;
  display: block;
  margin-bottom: 4px;
`;

export const ConfirmationTextStyled = styled.div`
  color: #b3d0e6;
  margin-bottom: 20px;
  text-align: center;
`;

export const ButtonContainerStyled = styled.div`
  display: flex;
  gap: 10px;
  justify-content: center;
`;

export const CancelButtonStyled = styled(ActionButtonStyled)`
  background-color: #6c757d;
  border-color: #6c757d;

  &:hover {
    border-color: #5a6268;
  }
`;

export const DeleteButtonStyled = styled(ActionButtonStyled)`
  background-color: #dc3545;
  border-color: #dc3545;

  &:hover {
    border-color: #c82333;
  }
`;
